<template>
  <div class="list-report-transaction-by-store">
    <Loader
      v-if="loaderEnabled"
      v-bind:logo="loaderLogo"
    ></Loader>
    <b-row>
      <b-col
        md="12"
        lg="12"
        sm="12"
      >
        <KTCodePreview>
          <template v-slot:preview>
            <transaction-store-filter
              :initial-filter="initialFilterData"
              @filter="handleFilter"
              ref="filterComponent"
            />

            <transaction-store-table
              :items="mainList"
              :loading="onLoadingList"
              :api-params="apiParams"
            />

            <transaction-store-pagination
              :total-items="mainList.totalRow"
              :total-pages="mainList.totalPage"
              :current-page="apiParams.page"
              @page-change="handlePageChange"
            />
          </template>
        </KTCodePreview>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { getToastInstance } from '@/utils/toastHelper';
import KTCodePreview from '@/view/content/CodePreview.vue';
import Loader from '@/view/content/Loader.vue';
import moment from 'moment';
import { mapGetters } from 'vuex';

import {
  TransactionStoreFilter,
  TransactionStorePagination,
  TransactionStoreTable,
} from './components';

import TransactionStoreService from './services/TransactionStoreService';

export default {
  components: {
    KTCodePreview,
    Loader,
    TransactionStoreFilter,
    TransactionStoreTable,
    TransactionStorePagination,
  },
  data() {
    return {
      title: 'Tổng hợp thu chi theo cửa hàng',

      mainList: {
        dataset: [],
        totalRow: 0,
        totalPage: 1,
      },

      onLoadingList: false,

      apiParams: {
        page: 1,
        pageSize: 10,
        storeId: '',
        fromDate: moment().format('DD/MM/YYYY'),
        toDate: moment().format('DD/MM/YYYY'),
      },

      initialFilterData: {
        page: 1,
        pageSize: 10,
        storeId: '',
        storeText: '',
        fromDate: moment().format('DD/MM/YYYY'),
        toDate: moment().format('DD/MM/YYYY'),
      },
    };
  },
  created() {
    this.loadBreadcum();
    this.initializeData();
  },
  mounted() {
    this.loadBreadcum();
  },
  methods: {
    ...getToastInstance(),

    /**
     * Initialize data by fetching stores and data
     */
    async initializeData() {
      try {
        const {
          stores,
          currentStoreId,
        } = await TransactionStoreService.fetchStoresByUser();

        this.$nextTick(() => {
          if (this.$refs.filterComponent) {
            if (stores.length === 1) {
              const s = stores[0];
              this.$refs.filterComponent.setSingleStore(s);
              this.initialFilterData.storeId = s.id;
              this.initialFilterData.storeText = s.name;
              this.apiParams.storeId = s.id;
            } else {
              this.$refs.filterComponent.setStores(stores);
              if (currentStoreId) {
                const current = stores.find((store) => store.id === currentStoreId);
                if (current) {
                  this.$refs.filterComponent.setSelectedStore(current);
                  this.initialFilterData.storeId = current.id;
                  this.initialFilterData.storeText = current.name;
                  this.apiParams.storeId = current.id;
                }
              }
            }
          }
        });

        this.fetchMainData();
      } catch (error) {
        console.error('Error initializing data:', error);
        this.makeToastFailure('Không thể tải dữ liệu ban đầu');
      }
    },

    /**
     * Fetch main transaction data
     */
    async fetchMainData() {
      try {
        const page = this.$route.query.page || 1;
        this.apiParams.page = page;

        this.onLoadingList = true;

        const responseData =
          await TransactionStoreService.fetchTransactionsByStore(
            this.apiParams,
          );
        this.mainList = responseData;
      } catch (error) {
        console.error('Error fetching transaction data:', error);
        const message = error.response?.data?.message || 'Lỗi khi tải dữ liệu';
        this.makeToastFailure(message);
      } finally {
        this.onLoadingList = false;
      }
    },

    /**
     * Handle filter action from filter component
     */
    handleFilter(filterData) {
      this.apiParams = { ...filterData };

      this.$router.push({
        query: { page: 1 },
      });

      this.fetchMainData();
    },

    /**
     * Handle page change from pagination component
     */
    handlePageChange(page) {
      this.apiParams.page = page;

      this.$router.push({
        query: { page },
      });

      this.fetchMainData();
    },

    /**
     * Set breadcrumb
     */
    loadBreadcum() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: 'Báo cáo', route: '/reports' },
        { title: 'Kế toán' },
        { title: this.title },
      ]);
    },
  },
  computed: {
    ...mapGetters(['breadcrumbs', 'pageTitle', 'layoutConfig']),
    loaderEnabled() {
      return !/false/.test(this.layoutConfig('loader.type'));
    },
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig('loader.logo');
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
};
</script>

<style lang="scss">
.list-report-transaction-by-store {
  .sttClass {
    width: 20px;
  }
}
</style>
